<template>
<div>
    <a v-if="this.currentUser" v-bind:class="this.btnclass" @click="signOut">Sign Out</a>
    <a v-if="!this.currentUser" v-bind:class="this.btnclass" @click="signUpModal()">Sign Up</a>
    <a v-if="!this.currentUser" v-bind:class="this.btnclass" @click="signInModal()">Sign In</a>

    <modal v-if="showModal" @close="showModal = false">
        <template #header>
            {{ signintext }}
        </template>
        <template #body>
            <ul class="links">
                <li>
                    <glSignIn :signintext="signintext" v-on:signInClick="signIn" />
                </li>
                <li>
                    <fbSignIn :signintext="signintext" v-on:signInClick="signIn" />
                </li>
                <li v-show="!showemail">
                    <emailSignIn :signintext="signintext" v-on:signInClick="signIn"/>
                </li>
                <li v-show="showemail">
                    <div class="card-panel" style="background-color: rgb(75, 58, 126);">
                        Enter your e-mail address &amp; <br/> we’ll send a magic link to your inbox. <br/>
                        <div class="input-field col s6">
                            <input placeholder="you@example.com" id="txtEmail" type="text" class="validate">
                        </div>
                        <button class="btn" @click="emailSignUp()">
                            {{signintext}}
                        </button>
                        <br/><br/>
                        <button class="btn btn-small grey" @click="showemail = false">
                            Cancel
                        </button>
                        <br/><br/>
                    </div>
                </li>
                <li>
                    <a @click.prevent="signUpModal()" v-if="!signingup" class="grey-text lighten-4">
                        New to quizMe? Sign Up!
                    </a>
                    <a @click.prevent="signInModal()" v-if="signingup" class="grey-text lighten-4">
                        Already have an account? Sign In
                    </a>
                </li>
            </ul>
        </template>
        <template #footer>&nbsp;</template>
    </modal>
</div>
</template>


<script lang="js">
import { Component, Vue }   from 'vue-property-decorator';
import * as firebase        from 'firebase/app';

import * as ping from '@/lib/usage_ping';
import { auth }             from '@/db/firestore.ts';
import store                from '@/store';
import Modal                from '@/components/Modal.vue';
import getProvider          from '@/lib/helpers/auth-getProvider';
import emailAuth            from '@/lib/helpers/auth-emailAuth';
import fbSignIn             from '@/components/btn-signin-fb.vue';
import glSignIn             from '@/components/btn-signin-google.vue';
import emailSignIn          from '@/components/btn-signin-email.vue';

// Issue #5: show errors and loading
export default {
    name: 'login',
    props: {
        btnclass: { type: String, default: 'signinbtn signBtnNew' }
    },
    data: function() {
        return {
            errors: [],
            loading: false,
            showModal: false,
            signintext: 'Sign in',
            signingup: false,
            showemail: false,
        }
    },
    components: {
        modal: Modal,
        fbSignIn,
        glSignIn,
        emailSignIn,
    },
    methods: {
        signIn(provStr) {
            this.loading = true;
            this.errors = [];

            if (provStr == 'email') {
                this.showemail = true;
            } else {
                var provider = getProvider(provStr)
                auth.signInWithPopup(provider)
                .then(response => {
                    this.doLogin(response);
                })
                .catch( error => {
                    console.error(error);
                    this.errors.push(error.message)
                    this.loading = false;
                })
            }
        },
        signOut() {
            firebase.auth().signOut();
            this.$store.dispatch('setUser', null);
            // needed to clear state so that newly logged in user
            // doesn't have previously logged in user state
            localStorage.clear();
            this.$router.go('/');
        },
        signInModal() {
            this.signintext = 'Sign in'
            this.signingup = false;
            this.showModal = true;
            this.showemail = false;
        },
        signUpModal() {
            this.signintext = 'Sign up'
            this.signingup = true;
            this.showModal = true;
            this.showemail = false;
        },
        emailSignUp() {
            const email = document.getElementById('txtEmail');
            emailAuth(email.value)
            .then(() => {
                this.showModal = false;
                window.localStorage.setItem('emailForSignIn', email.value);
                this.$toast.open({
                    message: "Email sent!  Check your inbox to sign in",
                    type: 'success',
                    duration: 5000,
                    position: 'top'
                });
                setTimeout(() => {
                    this.$router.push('/account/magic-link');
                }, 1000);
            })
            .catch((error) => {
                const msg = `There was an error with that link:\n ${error.message}`
                this.toastAndError(this, msg, e);
            });
        },
        doLogin(response) {
            this.$store.dispatch('setUser', response.user)
            if (response.additionalUserInfo.isNewUser) {
                ping.send({ type: ping.UserUsage.signup, uid: this.currentUser.uid })
                this.$router.push('/app/welcome')
            } else {
                ping.send({ type: ping.UserUsage.signin, uid: this.currentUser.uid })
                this.$router.push('/app')
            }
        }
    },
    created() {
        // Confirm the link is a sign-in with email link.
        if (firebase.auth().isSignInWithEmailLink(window.location.href)) {
        // Additional state parameters can also be passed via URL.
        // This can be used to continue the user's intended action before triggering
        // the sign-in operation.
        // Get the email if available. This should be available if the user completes
        // the flow on the same device where they started it.
        var email = window.localStorage.getItem('emailForSignIn');
        if (!email) {
            // User opened the link on a different device. To prevent session fixation
            // attacks, ask the user to provide the associated email again. For example:
            email = window.prompt('Please provide your email for confirmation');
        }
        // The client SDK will parse the code from the link for you.
        firebase.auth().signInWithEmailLink(email, window.location.href)
        .then((result) => {
            // Clear email from storage.
            window.localStorage.removeItem('emailForSignIn');
            this.$toast.open({
                message: "We signed you in!",
                type: 'success',
                duration: 3000,
                position: 'top'
            });
            this.doLogin(result);
        
        })
        .catch((error) => {
            // Some error occurred, you can inspect the code: error.code
            // Common errors could be invalid email and invalid or expired OTPs.
            const msg = `There was an error with that link:\n ${error.message}`
            this.toastAndError(this, msg, e);
        });
        }
    }
};
</script>

